import React, { useEffect, useState } from "react";
import { useLoginContext } from "contexts/LoginContext/LoginContext";
import { Typography, Row, Card } from "antd";
import RelevantStudyYearsDisplay from "components/RelevantStudyYearsDisplay/RelevantStudyYearsDisplay";
import axios from "axios";
import { StyledTitle } from "./styles";
import { StudyProgramQuota } from "./interface";

const { Text } = Typography;

interface Props {
  eventId: number;
}

const RelevantStudies: React.FC<Props> = ({ eventId }) => {
  const [studyProgramQuota, setStudyProgramQuota] = useState<StudyProgramQuota[]>();

  const { currentUser } = useLoginContext();

  useEffect(() => {
    if (!currentUser) return;
    axios.get(`/events/${eventId}/study-program-quotas/`).then(response => {
      // Manuell merging av linjer så man f.eks ikke får 5 forskjellige indøk-kvoter dersom hvert trinn har egen
      const quotas: Array<StudyProgramQuota> = [];
      for (let i = 0; i < response.data.length; i += 1) {
        let exists = false;
        for (let k = 0; k < quotas.length; k += 1) {
          if (response.data[i].study_programme === quotas[k].study_programme) {
            const merged = quotas[k].year_levels_accepted.concat(response.data[i].year_levels_accepted);
            quotas[k].year_levels_accepted = merged;
            exists = true;
          }
        }
        if (!exists) quotas.push(response.data[i]);
      }
      setStudyProgramQuota(quotas);
    });
  }, [eventId, currentUser]);

  return (
    <Card>
      <StyledTitle level={4}>Aktuelle linjer og trinn</StyledTitle>

      {!currentUser ? (
        <Text italic>Logg inn for å se hvem arrengementet er åpent for</Text>
      ) : studyProgramQuota?.length === 0 ? (
        <Text italic>Ikke bestemt</Text>
      ) : (
        studyProgramQuota?.map(quota => (
          <Row key={quota.study_programme} style={{ paddingBottom: "10px" }}>
            <Row style={{ width: "100%" }}>
              <Text>{quota.study_programme_name}</Text>
            </Row>
            <Row>
              <RelevantStudyYearsDisplay yearLevelsAccepted={quota.year_levels_accepted} />
            </Row>
          </Row>
        ))
      )}
    </Card>
  );
};

export default RelevantStudies;
